import { render, staticRenderFns } from "./SupplierTestimoniesControl.vue?vue&type=template&id=0904b489&scoped=true&"
import script from "./SupplierTestimoniesControl.vue?vue&type=script&lang=js&"
export * from "./SupplierTestimoniesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904b489",
  null
  
)

export default component.exports